var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SaySLogo = function (_a) {
    var style = _a.style;
    return (_jsx("svg", __assign({ width: "21", height: "16", viewBox: "0 0 21 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: style }, { children: _jsx("path", { d: "M9.71413 6.00895C5.54741 6.00895 4.09287 5.95301 4.09287 4.73455C4.09287 3.66154 5.51888 3.31636 10.1348 3.31636C14.988 3.31636 18.8856 4.60643 18.8856 4.60643L19.1866 4.50685V1.24531C19.1866 1.24531 15.6 0 10.0503 0C4.78769 0 0 0.803916 0 5.28783C0 9.70741 3.4635 9.76783 11.0109 9.76783C14.8006 9.76783 16.5902 9.75161 16.5902 11.0702C16.5902 12.2831 14.4269 12.6366 9.8814 12.6366C3.82881 12.635 0.378741 11.0915 0.378741 11.0915L0.0844755 11.238V14.645L0.20979 14.6842C2.80448 15.5027 6.2993 15.9536 10.0503 15.9536C17.5015 15.9536 20.6797 14.8274 20.6797 10.711C20.6808 6.55105 17.7622 6.00895 9.71245 6.00895H9.71413Z", fill: "black" }) })));
};
export default SaySLogo;
